/**
 * Encode each path segment so spaces / special chars in media URLs
 * are safe on mobile Safari (prefer URL-safe filenames when possible).
 */
export function mediaUrl(path) {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  return path
    .split('/')
    .map((segment, i) => (i === 0 ? segment : encodeURIComponent(segment)))
    .join('/');
}
